// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M3 13V3.5C3 2.4 3.9 1.5 5 1.5H12C12.55 1.5 13 1.95 13 2.5V11.5H5C3.9 11.5 3 12.17 3 13C3 13.83 3.9 14.5 5 14.5H13',
  'M12.5 11.65V14.35',
  'M 6 5.27 V 5.1 C 6 4.82 6.22 4.6 6.5 4.6 H 9.5 C 9.78 4.6 10 4.82 10 5.1 V 5.27 M 8 4.6 V 8.6 M 7.33 8.6 H 8.67',
];
